<template>
  <div class="operation">
    <AdornmentsInput
      v-model="text"
      class="search-text"
      placeholder="ご予約者名、電話番号、会社名などを入力してください。"
      :prefixIcon="SearchIcon"
    />
    <div class="conditions">
      <SelectBox class="medium-select" v-model.number="inputBy" :items="mediumMap" />
      <SelectBox class="status-select" v-model.number="status" :items="statusMap" />
      <SelectBox class="date-type-select" v-model.number="dateType" :items="dateTypeMap" />
      <CalendarInput
        v-model="startDate"
        :holidayList="holidayList"
        :businessDay="businessDay"
        :reserveCalendar="reserveCalendar"
        :busy="busy"
        @setDate="setDate"
        @beforeShow="setDate(startDate)"
      />
      <span>〜</span>
      <CalendarInput
        v-model="endDate"
        :holidayList="holidayList"
        :businessDay="businessDay"
        :reserveCalendar="reserveCalendar"
        :busy="busy"
        @setDate="setDate"
        @beforeShow="setDate(endDate)"
      />
      <Button small primary class="button" @click="search">表示</Button>
    </div>
  </div>
</template>

<script>
import { models } from '@/utils/vue'
import AdornmentsInput from '@/components/molecules/AdornmentsInput'
import SelectBox from '@/components/atoms/SelectBox'
import Button from '@/components/atoms/Button'
import SearchIcon from '@/components/icons/search'
import CalendarInput from '@/components/molecules/CalendarInput'

export default {
  name: 'Operation',
  components: {
    AdornmentsInput,
    SelectBox,
    Button,
    CalendarInput,
  },
  props: {
    condition: { type: Object },
    holidayList: { type: Array },
    businessDay: { type: Object, default: () => {} },
    mediumMap: { type: Map },
    dateTypeMap: { type: Object },
    /** 予約数一覧 */
    reserveCalendar: { type: Object, default: () => ({}) },
    /** ローディング */
    busy: { type: Boolean, default: false },
  },
  data() {
    return {
      SearchIcon,
    }
  },
  computed: {
    ...models(
      ['inputBy', 'status', 'dateType', 'text'],
      ({ condition }, key) => condition[key],
      (vm, key, value) => vm.$emit('updateCondition', { [key]: value }),
    ),
    statusMap() {
      return { 0: '全ステータス', 1: '新規受付', 2: '変更', 3: 'キャンセル' }
    },
    startDate: {
      get() {
        return this.condition.startDate
      },
      set(value) {
        this.updateStartDate(value)
      },
    },
    endDate: {
      get() {
        return this.condition.endDate
      },
      set(value) {
        this.updateEndDate(value)
      },
    },
  },
  methods: {
    updateStartDate(date) {
      this.$emit('updateStartDate', date)
    },
    updateEndDate(date) {
      this.$emit('updateEndDate', date)
    },
    search() {
      this.$emit('search')
    },
    setDate(date) {
      this.$emit('setDate', date)
    },
  },
}
</script>

<style lang="postcss" scoped>
.operation {
  align-items: center;
  box-sizing: border-box;
  display: grid;
  grid-auto-flow: row;
  grid-gap: 8px;
  padding: 8px;

  .search-text {
    height: 48px;
    max-width: 100%;
    >>> input {
      &::placeholder {
        color: var(--light-gray);
      }
    }
    >>> svg {
      fill: var(--light-gray);
    }
  }

  .conditions {
    align-items: center;
    display: grid;
    grid-auto-flow: column;
    grid-gap: 8px;
    justify-content: start;
    width: 100%;

    .medium-select {
      width: 224px;
    }

    .status-select {
      width: 160px;
    }

    .date-type-select {
      width: 104px;
    }

    >>> .calendar-button {
      font-size: 15px;
    }

    .button {
      font-size: 18px;
      width: 88px;
    }
  }

  .responsive & {
    @media screen and (max-width: 1020px) {
      display: none;
    }
  }
}
</style>
